import { NeoState } from '~/store';

export const selectAlertVisibilityBy = (key: string) => (state: NeoState) =>
  state?.alerts?.alertsVisibility[key] ?? true;
